// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Quests_container__gaQRb {
  padding-top: 124px;
}
.Quests_container__gaQRb .Quests_title__PPI-z {
  font-size: 64px;
  font-weight: 700;
  font-style: normal;
  align-items: center;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  font-size: 40px;
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_filters__vYbZR {
  display: flex;
  gap: 24px;
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_filters__vYbZR .Quests_filter__qYj7g {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  background: #3a2159;
  border-radius: 8px;
  color: #d8cedf;
  cursor: pointer;
  display: flex;
  gap: 8px;
  height: 46px;
  padding: 10px 22px;
  position: relative;
  transition: all 0.2s linear;
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_filters__vYbZR .Quests_filter__qYj7g .Quests_filterWrapper__rnXUM {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  background-color: #3a2159;
  border-radius: 8px;
  color: #E0E0E0;
  left: 0;
  padding: 8px 0;
  position: absolute;
  top: 120%;
  width: 178px;
  z-index: 0;
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_filters__vYbZR .Quests_filter__qYj7g .Quests_filterWrapper__rnXUM .Quests_filterItem__PGbM- {
  cursor: pointer;
  margin-bottom: 3px;
  padding: 6px 16px;
  transition: all 0.2s linear;
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_filters__vYbZR .Quests_filter__qYj7g .Quests_filterWrapper__rnXUM .Quests_filterItem__PGbM-:hover {
  background-color: rgba(220, 220, 220, 0.1);
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_filters__vYbZR .Quests_filter__qYj7g .Quests_filterWrapper__rnXUM .Quests_selectedFilter__pArzc {
  background-color: rgba(220, 220, 220, 0.1);
  color: #fff;
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_filters__vYbZR .Quests_filterBlue__QpelO {
  background-color: #193B41;
  color: #0CDCEA;
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_filters__vYbZR .Quests_filterPurple__f\\+vxm {
  background-color: #3A2159;
  color: #AE6FFF;
  transition: all 0.2s linear;
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_filters__vYbZR .Quests_filterPurple__f\\+vxm:hover {
  background-color: #4A2C6F;
}
.Quests_container__gaQRb .Quests_wrapper__69XBl {
  align-items: start;
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr 1fr 1fr;
  margin-top: 50px;
}
.Quests_container__gaQRb .Quests_wrapper__69XBl .Quests_loaderContainer__6FmUQ {
  font-size: 24px;
  font-weight: 700;
  font-style: normal;
  color: #F9F9F9;
  display: flex;
  grid-column: span 4;
  justify-content: center;
  margin-top: 50px;
}
.Quests_container__gaQRb .Quests_wrapper__69XBl .Quests_loaderContainer__6FmUQ .Quests_loaderWrapper__HUlmg {
  background-color: #ffffff;
  border-radius: 133px;
  height: 8px;
  margin-top: 32px;
  width: 236px;
}
.Quests_container__gaQRb .Quests_wrapper__69XBl .Quests_loaderContainer__6FmUQ .Quests_loaderWrapper__HUlmg .Quests_loader__wUXsu {
  background-color: #4A2C6F;
  border-radius: 133px;
  height: 100%;
  animation: Quests_loader__wUXsu 0.5s ease-in-out forwards;
  width: 0;
}
.Quests_container__gaQRb .Quests_wrapper__69XBl .Quests_empty__2JXSO {
  font-size: 32px;
  font-weight: 700;
  font-style: normal;
  color: #ffffff;
  grid-column: span 4;
  margin-top: 50px;
  text-align: center;
}
.Quests_container__gaQRb .Quests_wrapper__69XBl .Quests_empty__2JXSO .Quests_emptyInfo__fEF\\+q {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  margin-top: 20px;
}
.Quests_container__gaQRb .Quests_wrapper__69XBl .Quests_empty__2JXSO .Quests_emptyInfo__fEF\\+q .Quests_link__DCj9i {
  color: #FD4C0A;
}
.Quests_container__gaQRb .Quests_more__47YgZ {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  position: relative;
}
.Quests_container__gaQRb .Quests_more__47YgZ .Quests_btn__0NAZo button {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  background-color: #333217;
  border-radius: 8px;
  color: #EAD40C;
  cursor: pointer;
  height: 46px;
  transition: all 0.2s linear;
  width: 107px;
}
.Quests_container__gaQRb .Quests_more__47YgZ .Quests_btn__0NAZo button .Quests_loader__wUXsu {
  animation: Quests_spin__abXXa 0.5s linear infinite;
  width: 24px;
}
.Quests_container__gaQRb .Quests_more__47YgZ .Quests_btn__0NAZo button:hover {
  background-color: #494711;
}
.Quests_container__gaQRb .Quests_up__AFGrL {
  align-items: center;
  background-color: #3A2159;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  height: 40px;
  justify-content: center;
  position: absolute;
  right: 0;
  transition: all 0.2s linear;
  width: 40px;
}
.Quests_container__gaQRb .Quests_up__AFGrL:hover {
  background-color: #4A2C6F;
}

@keyframes Quests_loader__wUXsu {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
@media (max-width: 1493px) {
  .Quests_container__gaQRb .Quests_wrapper__69XBl {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 850px) {
  .Quests_container__gaQRb {
    padding-top: 104px;
  }
  .Quests_container__gaQRb .Quests_title__PPI-z {
    display: block;
    font-size: 36px;
  }
  .Quests_container__gaQRb .Quests_title__PPI-z .Quests_filters__vYbZR .Quests_filter__qYj7g {
    display: inline-flex;
    margin-top: 32px;
    padding: 10px 18px;
  }
  .Quests_container__gaQRb .Quests_wrapper__69XBl {
    grid-template-columns: 1fr;
    margin-top: 24px;
  }
  .Quests_container__gaQRb .Quests_wrapper__69XBl .Quests_empty__2JXSO {
    font-size: 24px;
    font-weight: 700;
    font-style: normal;
  }
  .Quests_container__gaQRb .Quests_wrapper__69XBl .Quests_empty__2JXSO .Quests_emptyInfo__fEF\\+q {
    font-size: 16px;
    font-weight: 400;
    font-style: normal;
    margin-top: 20px;
  }
}
@keyframes Quests_spin__abXXa {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Quests/Quests.module.scss","webpack://./src/assets/styles/_fonts.scss","webpack://./src/assets/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;AADF;AAGE;ECJA,eAAA;EACA,gBAAA;EACA,kBAAA;EDKE,mBAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;AAAJ;AAEI;EACE,aAAA;EACA,SAAA;AAAN;AAEM;EC+BJ,eAAA;EACA,gBAAA;EACA,kBAAA;ED9BM,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;AACR;AACQ;EC4BN,eAAA;EACA,gBAAA;EACA,kBAAA;ED3BQ,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,OAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AAEV;AAAU;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,2BAAA;AAEZ;AAAY;EACE,0CAAA;AAEd;AAEU;EACE,0CAAA;EACA,WAAA;AAAZ;AASM;EACE,yBAAA;EACA,cAAA;AAPR;AAUM;EACE,yBAAA;EACA,cAAA;EACA,2BAAA;AARR;AAUQ;EACE,yBAAA;AARV;AAcE;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,kCAAA;EACA,gBAAA;AAZJ;AAcI;ECzEF,eAAA;EACA,gBAAA;EACA,kBAAA;ED0EI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAXN;AAaM;EACE,yBEtGE;EFuGF,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AAXR;AAaQ;EACE,yBAAA;EACA,oBAAA;EACA,YAAA;EACA,yDAAA;EACA,QAAA;AAXV;AAgBI;ECzGF,eAAA;EACA,gBAAA;EACA,kBAAA;ED0GI,cEzHI;EF0HJ,mBAAA;EACA,gBAAA;EACA,kBAAA;AAbN;AAeM;ECnFJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDoFM,gBAAA;AAZR;AAcQ;EACE,cE3HC;AF+GX;AAkBE;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAhBJ;AAoBM;ECjGJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDkGM,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,2BAAA;EACA,YAAA;AAjBR;AAmBQ;EACE,kDAAA;EACA,WAAA;AAjBV;AAoBQ;EACE,yBAAA;AAlBV;AAwBE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;AAtBJ;AAwBI;EACE,yBAAA;AAtBN;;AA2BA;EACE;IACE,QAAA;EAxBF;EA0BA;IACE,WAAA;EAxBF;AACF;AA2BA;EAGI;IACE,8BAAA;EA3BJ;AACF;AA+BA;EACE;IACE,kBAAA;EA7BF;EA+BE;IACE,cAAA;IACA,eAAA;EA7BJ;EAgCM;IACE,oBAAA;IACA,gBAAA;IACA,kBAAA;EA9BR;EAmCE;IACE,0BAAA;IACA,gBAAA;EAjCJ;EAmCI;IChNJ,eAAA;IACA,gBAAA;IACA,kBAAA;EDgLA;EAiCM;ICzKN,eAAA;IACA,gBAAA;IACA,kBAAA;ID0KQ,gBAAA;EA9BR;AACF;AAoCA;EACE;IAAK,uBAAA;EAjCL;EAkCA;IAAO,yBAAA;EA/BP;AACF","sourcesContent":["@import '../../assets/styles/global.scss';\n\n.container {\n  padding-top: 124px;\n\n  .title {\n    @include h1;\n\n    align-items: center;\n    color: #ffffff;\n    display: flex;\n    justify-content: space-between;\n    font-size: 40px;\n\n    .filters {\n      display: flex;\n      gap: 24px;\n\n      .filter {\n        @include subtitle6m;\n\n        align-items: center;\n        background: #3a2159;\n        border-radius: 8px;\n        color: #d8cedf;\n        cursor: pointer;\n        display: flex;\n        gap: 8px;\n        height: 46px;\n        padding: 10px 22px;\n        position: relative;\n        transition: all .2s linear;\n\n        .filterWrapper {\n          @include body1;\n\n          background-color: #3a2159;\n          border-radius: 8px;\n          color: #E0E0E0;\n          left: 0;\n          padding: 8px 0;\n          position: absolute;\n          top: 120%;\n          width: 178px;\n          z-index: 0;\n\n          .filterItem {\n            cursor: pointer;\n            margin-bottom: 3px;\n            padding: 6px 16px;\n            transition: all .2s linear;\n\n            &:hover {\n              background-color: rgba(220, 220, 220, .1);\n            }\n          }\n\n          .selectedFilter {\n            background-color: rgba(220, 220, 220, .1);\n            color: #fff;\n          }\n        }\n\n        // &:hover {\n        //   background-color: #494711;\n        // }\n      }\n\n      .filterBlue {\n        background-color: #193B41;\n        color: #0CDCEA;\n      }\n\n      .filterPurple {\n        background-color: #3A2159;\n        color: #AE6FFF;\n        transition: all .2s linear;\n\n        &:hover {\n          background-color: #4A2C6F;\n        }\n      }\n    }\n  }\n\n  .wrapper {\n    align-items: start;\n    display: grid;\n    gap: 24px;\n    grid-template-columns: 1fr 1fr 1fr;\n    margin-top: 50px;\n\n    .loaderContainer {\n      @include subtitle1b;\n      \n      color: #F9F9F9;\n      display: flex;\n      grid-column: span 4;\n      justify-content: center;\n      margin-top: 50px;\n\n      .loaderWrapper {\n        background-color: $c-white;\n        border-radius: 133px;\n        height: 8px;\n        margin-top: 32px;\n        width: 236px;\n        \n        .loader {\n          background-color: #4A2C6F;\n          border-radius: 133px;\n          height: 100%;\n          animation: loader .5s ease-in-out forwards;\n          width: 0;\n        }\n      }\n    }\n\n    .empty {\n      @include h3;\n\n      color: $c-white;\n      grid-column: span 4;\n      margin-top: 50px;\n      text-align: center;\n\n      .emptyInfo {\n        @include subtitle5;\n\n        margin-top: 20px;\n\n        .link {\n          color: $c-yellow;\n        }\n      }\n    }\n  }\n\n  .more {\n    display: flex;\n    justify-content: center;\n    margin-top: 40px;\n    position: relative;\n\n    .btn {\n\n      button {\n        @include subtitle6m;\n  \n        background-color: #333217;\n        border-radius: 8px;\n        color: #EAD40C;\n        cursor: pointer;\n        height: 46px;\n        transition: all .2s linear;\n        width: 107px;\n  \n        .loader {\n          animation: spin .5s linear infinite;\n          width: 24px;\n        }\n\n        &:hover {\n          background-color: #494711;\n        }\n      }\n    }\n  }\n\n  .up {\n    align-items: center;\n    background-color: #3A2159;\n    border-radius: 8px;\n    cursor: pointer;\n    display: flex;\n    height: 40px;\n    justify-content: center;\n    position: absolute;\n    right: 0;\n    transition: all .2s linear;\n    width: 40px;\n\n    &:hover {\n      background-color: #4A2C6F;\n    }\n  }\n}\n\n@keyframes loader {\n  0% {\n    width: 0;\n  }\n  100% {\n    width: 100%;\n  }\n}\n\n@media (max-width: 1493px) {\n  .container {\n\n    .wrapper {\n      grid-template-columns: 1fr 1fr;\n    }\n  }\n}\n\n@media (max-width: 850px) {\n  .container {\n    padding-top: 104px;\n\n    .title {\n      display: block;\n      font-size: 36px;\n\n      .filters {\n        .filter {\n          display: inline-flex;\n          margin-top: 32px;\n          padding: 10px 18px;\n        }\n      }\n    }\n\n    .wrapper {\n      grid-template-columns: 1fr;\n      margin-top: 24px;\n\n      .empty {\n        @include subtitle1b;\n\n        .emptyInfo {\n          @include body1;\n\n          margin-top: 20px;\n        }\n      }\n    }\n  }\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n","$c-white: #ffffff;\n\n$c-black: #1B1E23;\n$c-light-black: #242424;\n\n$c-dark-grey: rgba(36, 36, 36, .3);\n$c-light-grey: #E0E0E0;\n$c-light-grey-lines: rgba(220, 220, 220, .1);\n\n$c-yellow: #FD4C0A;\n$c-light-yellow: #FFEB31;\n$c-dark-yellow: #333217;\n$c-dark-yellow-focus: #494711;\n\n$c-blue-main: #0CDCEA;\n$c-light-blue: #69F6FF;\n$c-dark-blue-btns: #193B41;\n$c-dark-blue-hover: #0A5360;\n\n$c-red: #F44336;\n$c-dark-red: #351C1D;\n\n$c-green: #07EF9C;\n$c-dark-green: #11362C;\n\n$c-blue: #1D92FF;\n$c-dark-blue: #19334F;\n\n$c-parimatch: #F1F813;\n$c-parimatch-light: rgb(241, 248, 19, .15);\n\n$c-dota: #BF2E1A;\n$c-dota-light: rgba(191, 46, 26, .15);\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Quests_container__gaQRb`,
	"title": `Quests_title__PPI-z`,
	"filters": `Quests_filters__vYbZR`,
	"filter": `Quests_filter__qYj7g`,
	"filterWrapper": `Quests_filterWrapper__rnXUM`,
	"filterItem": `Quests_filterItem__PGbM-`,
	"selectedFilter": `Quests_selectedFilter__pArzc`,
	"filterBlue": `Quests_filterBlue__QpelO`,
	"filterPurple": `Quests_filterPurple__f+vxm`,
	"wrapper": `Quests_wrapper__69XBl`,
	"loaderContainer": `Quests_loaderContainer__6FmUQ`,
	"loaderWrapper": `Quests_loaderWrapper__HUlmg`,
	"loader": `Quests_loader__wUXsu`,
	"empty": `Quests_empty__2JXSO`,
	"emptyInfo": `Quests_emptyInfo__fEF+q`,
	"link": `Quests_link__DCj9i`,
	"more": `Quests_more__47YgZ`,
	"btn": `Quests_btn__0NAZo`,
	"spin": `Quests_spin__abXXa`,
	"up": `Quests_up__AFGrL`
};
export default ___CSS_LOADER_EXPORT___;
